import useMutation from "src/hooks/useMutation";

function useManualCreateBulkReturnProcessing(id) {
  return useMutation({
    path: `/api/v1/return-logs/${id}/return-log-details`,
    method: "POST",
    mutateRelatedDataList: {
      mutatePath: `/api/v1/return-logs/${id}/process`,
      shouldRevalidate: true,
    },
  });
}

export default useManualCreateBulkReturnProcessing;
